//Parse phone number
const parsePhoneNumber = (phnNumber) => {
  var areaCd, phn;
  if (/^\([0-9]{3}\) [0-9]{3}-[0-9]{4}$/.test(phnNumber)) {
    var phnNumberPlain = phnNumber.replace(/\D/g, '');
    areaCd = phnNumberPlain.substr(0, 3);
    phn = phnNumberPlain.substr(3, 7);
  }
  else if (/^[0-9]{10}$/.test(phnNumber)) {
    areaCd = phnNumber.substr(0, 3);
    phn = phnNumber.substr(3, 7);
  }
  return [areaCd, phn];
};

const parseIfJson = (input) => {
  try {
    const parsed = JSON.parse(input);
    // Check if the parsed result is an object or array
    if (typeof parsed === 'object' && parsed !== null) {
      return parsed;
    }
  } catch (e) {
    // If parsing fails, return the original input
  }
  return input;
}

export {
  parsePhoneNumber,
  parseIfJson
};